import React from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useMemberBenefits } from '@verzekeringapp-mono/shared/src/hooks/use_member_benefits'
import { useParams } from 'react-router-dom'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getMemberBenefit } from '@verzekeringapp-mono/shared/src/state/selectors/member_benefits'
import MemberBenefitVoucher from './components/member_benefit_voucher'
import MemberBenefitCampaign from './components/member_benefit_campaign'
import MemberBenefitContent from './components/member_benefit_content'
import MemberBenefitVote from './components/member_benefit_vote'
import { format } from 'date-fns'
import { selectEffectiveTogglesForCurrent } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import NotCooperationMemberMessage from '../components/not_cooperation_member_message'

const MemberBenefitDetailScreen: React.FC = () => {
  const { id } = useParams()
  const memberBenefit = useAppSelector(getMemberBenefit(id ?? ''))
  const relationToggles = useAppSelector(selectEffectiveTogglesForCurrent)
  const isCooperationMember = relationToggles?.cooperationMembership ?? false

  useMemberBenefits(id, { enabled: isCooperationMember })

  if (!relationToggles) {
    return null
  }

  return (
    <ScreenWrapper
      breadCrumbsOverride={[
        { label: 'Ledenvoordelen', path: '/ledenvoordelen' },
        {
          label: 'Ledenvoordeel',
          path: `/ledenvoordelen/${id}`
        }
      ]}
    >
      {!isCooperationMember && (
        <NotCooperationMemberMessage />
      )}

      {isCooperationMember && (
        <div className='md:w-full lg:w-1/2'>
          <div className='w-full aspect-[2/1]'>
            {memberBenefit?.image
              ? (
                <img
                  src={memberBenefit?.image}
                  className='w-full h-full object-cover rounded'
                  alt=''
                />
              )
              : (
                <div className='h-full w-full rounded bg-surface-card-disabled' />
              )}
          </div>

          <p className='mt-4 text-xl'>{memberBenefit?.title}</p>

          {memberBenefit && (
            <div className='gap-2 mt-4'>
              <MemberBenefitVoucher memberBenefit={memberBenefit} />

              <MemberBenefitCampaign memberBenefit={memberBenefit} />

              <MemberBenefitContent memberBenefit={memberBenefit} />

              <MemberBenefitVote memberBenefit={memberBenefit} />

              {memberBenefit?.startDate && memberBenefit?.endDate && (
                <p className='paragraph-light mb-6 mt-4'>{`Geldig van ${format(
                  memberBenefit.startDate,
                  'dd-MM-yyyy'
                )} tot ${format(memberBenefit.endDate, 'dd-MM-yyyy')}`}</p>
              )}
            </div>
          )}
        </div>
      )}
    </ScreenWrapper>
  )
}

export default MemberBenefitDetailScreen
